const styles = {
  filterRow: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 2,
  },
  filterLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    flexWrap: 'wrap',
  },
  rightControls: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  fabButton: {
    width: '48px',
    height: '48px',
    minWidth: '48px',
    minHeight: '48px',
    borderRadius: '50%',
    backgroundColor: '#5236AB',
    color: '#F0F0F0',
    border: '1px solid #5236AB',
    padding: 0,
    '&:hover': {
      backgroundColor: '#E0E0E0',
    },
  },
  viewToggleButtonActive: {
    width: '52px',
    height: '48px',
    border: '1px solid #5236AB',
    padding: '8px 16px',
    backgroundColor: '#5236AB',
    color: '#fff',
    borderRadius: 0,
  },
  viewToggleButtonInactive: {
    width: '50px',
    height: '48px',
    border: '1px solid #5236AB',
    padding: '8px 16px',
    backgroundColor: '#fff',
    color: '#5236AB',
    borderRadius: 0,
  },
};

export default styles;
